<script lang="ts" setup>
const props = defineProps({
  categorizedProducts: {
    type: Object,
    required: true
  }
});
const lists = ref([
  {
    title: '居家淨化',
    data: [
      {
        title: 'dyson',
        link: '#'
      },
      {
        title: 'vermicular',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'oral-b',
        link: '#'
      }
    ]
  },
  {
    title: '生活用品',
    data: [
      {
        title: 'dyson',
        link: '#'
      },
      {
        title: 'vermicular',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'oral-b',
        link: '#'
      }
    ]
  },
  {
    title: '健康美容',
    data: [
      {
        title: 'dyson',
        link: '#'
      },
      {
        title: 'vermicular',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'oral-b',
        link: '#'
      }
    ]
  },
  {
    title: '廚房家電',
    data: [
      {
        title: 'dyson',
        link: '#'
      },
      {
        title: 'vermicular',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'oral-b',
        link: '#'
      }
    ]
  },
  {
    title: '餐廚用品',
    data: [
      {
        title: 'dyson',
        link: '#'
      },
      {
        title: 'vermicular',
        link: '#'
      },
      {
        title: 'sodastream',
        link: '#'
      },
      {
        title: 'panasonic',
        link: '#'
      },
      {
        title: 'oral-b',
        link: '#'
      }
    ]
  }
]);
</script>

<template>
  <section class="brands" id="sectionBrands">
    <div class="brands__intro">
      <Intro class="display80 align-left" subtitle="brands" :data="{
        title: '代理品牌'
      }" />
    </div>
    <div class="brands__right">
      <ul class="brands__lists">
        <template v-for="(item, index) in categorizedProducts">
          <li  v-if="item.category.subject !=='全部品牌'"  :key="item.category.id">
            <div class="brands__lists__top">{{ item.category.subject }}</div>
            <div class="brands__lists__bottom">
              <nuxt-link :to="`/brand/${data.seo?.meta_slug || data.id}`" v-for="data in item.data" :key="data.id">{{
          data.subject
        }}</nuxt-link>
            </div>
          </li>
       </template>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.brands {
  padding-top: toRem(200);
  padding-bottom: toRem(100);
  padding-left: toRem(24);
  padding-right: toRem(24);
  margin-left: toRem(-24);
  margin-right: toRem(-24);
  background-color: $color-white-1;
  @include grid;

  @include max-media(1180) {
    padding-top: toRem(100);
  }

  &__intro {
    grid-column: 1 / span 2;

    @include max-media(1180) {
      grid-column: 1 / span 12;
      margin-bottom: toRem(30);
    }
  }

  &__right {
    grid-column: 4 / span 9;

    @include max-media(1180) {
      grid-column: 1 / span 12;
    }
  }

  &__lists {
    @include grid(9, 24);
    grid-template-columns: repeat(auto-fill, calc((100% - 48px) / 3));

    @include max-media(640) {
      grid-template-columns: repeat(auto-fill, calc((100% - 48px) / 2));
    }

    li {
      margin-bottom: toRem(56);
    }

    &__top {
      padding-bottom: toRem(12);
      margin-bottom: toRem(12);
      border-bottom: 1px solid $color-gray-line;
      font-size: toRem(16);
      font-weight: 400;
      line-height: 1.45;
      color: $color-brand-3;
    }

    &__bottom {
      a {
        display: block;
        font-family: $font-TextaAlt;
        font-size: toRem(24);
        font-weight: 500;
        // line-height: 0.8;
        letter-spacing: toRem(-0.48);
        // margin-bottom: toRem(16);

        @include max-media(640) {
          font-size: toRem(20);
        }
      }
    }
  }
}
</style>
